import { useEffect, useState } from 'react';

import { AxiosResponse } from 'axios';
import { HTTP_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import { IncidentStatusAggregationResponse } from '../types/Incidents';
import { httpGet } from '../../../../components/utils';

interface Params {
    lastActivityFilterInDays: number;
}

const useGetIncidentsStatusOverview = ({ lastActivityFilterInDays }: Params) => {
    const [data, setData] = useState<IncidentStatusAggregationResponse>();
    const [isFetching, setIsFetching] = useState(false);
    const [error, setError] = useState<string>();

    useEffect(() => {
        const fetchIncidentsStatusOverview = async () => {
            setIsFetching(true);
            setError(undefined);

            try {
                const response = (await httpGet('/incidents/overview/status', {
                    [HTTP_OPTIONS.REQ_OPTIONS]: {
                        params: {
                            lastActivityFilterInDays
                        }
                    }
                })) as unknown as AxiosResponse<IncidentStatusAggregationResponse>;

                setData(response.data);
            } catch (err) {
                setError('Failed to get incidents status overview from server');
            }
            setIsFetching(false);
        };

        fetchIncidentsStatusOverview();
    }, [lastActivityFilterInDays]);

    return { data, isFetching, error };
};

export default useGetIncidentsStatusOverview;
